import React from 'react';

import StepperDrawerHeader from '../../../common/components/StepperDrawerHeader/StepperDrawerHeader';
import { useDuplicateAdsStepperContext } from '../../DuplicateAdsStepperProvider/DuplicateAdsStepperProvider';

type Props = {
  onNext?: () => void;
  title: string;
  confirmButtonDisabled: boolean;
  confirmText?: string;
  loading?: boolean;
  tooltipText?: string;
};

const MultipleDuplicateAdsStepperHeader = ({
  title,
  onNext,
  confirmButtonDisabled,
  confirmText = 'Next',
  tooltipText,
  loading,
}: Props): React.JSX.Element => {
  const { onCloseStepper, step, goToNextStep, goToPrevStep } = useDuplicateAdsStepperContext();

  return (
    <StepperDrawerHeader
      title={title}
      step={step}
      confirmButtonDisabled={confirmButtonDisabled}
      onNext={onNext ?? goToNextStep}
      onCancel={onCloseStepper}
      onBack={goToPrevStep}
      confirmText={confirmText}
      tooltipText={tooltipText}
      tooltipId="multiple-duplicate-ads-next-button"
      loading={loading}
    />
  );
};

export default MultipleDuplicateAdsStepperHeader;
